<template>
  <div class="c-flex-c1 background">

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <!-- PC TOOLBAR -->
      <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

        <v-breadcrumbs>
          <v-breadcrumbs-item to="/dashboard/">
            Home
          </v-breadcrumbs-item>
          <span class="pl-2 pr-2">/</span>
          <v-breadcrumbs-item disabled>
            Price Lists
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-layout align-center>
          <div class="headline font-weight-medium">
            Price Lists {{ pageCount }}
          </div>
        </v-layout>

      </div>

      <!-- MOBILE toolbar -->
      <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
        <v-layout align-center>
          <v-btn icon @click="drawer = !drawer">
            <v-icon>menu</v-icon>
          </v-btn>
          <v-flex class="text-ellipsed text-sans font-weight-bold">
            Price Lists
          </v-flex>
        </v-layout>
      </div>

    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div>

      <!-- NEW CARD -->
      <v-card class="ma-2">
        <!-- pagination toolbar -->
        <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

          <transition
          name="slide-x-reverse-transition"
          mode="out-in">

            <!-- ITEMS -->
            <div 
            v-if="selectedCount === 0"
            key="1"
            class="c-flex-r align-center subheading">

              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectAll">
                    <v-list-item-title>Select all</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectNone">
                    <v-list-item-title>Select none</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
              text
              outlined
              class="mr-2"
              @click="newPriceList">
                <v-icon>add</v-icon>
                <div class="ml-1 text--text">
                  New price list
                </div>
              </v-btn>

              <v-menu offset-y :close-on-content-click="false" min-width="280px">
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    outlined
                    v-on="on"
                  >
                    <v-icon small>mdi-filter</v-icon>
                    <div class="ml-1 text--text">
                      Filter
                    </div>
                    <span v-if="activeFilterCount > 0">
                      &nbsp;|&nbsp;
                      <span class="color1--text">
                        {{ activeFilterCount }}
                      </span>
                    </span>
                  </v-btn>
                </template>
                <v-card class="">
                  <v-layout justify-center align-center class="backgroundCard pa-2">
                    <v-btn outlined small @click="clearFilters">
                      Clear
                    </v-btn>
                    <v-spacer></v-spacer>
                    Filters
                    <v-spacer></v-spacer>
                    <v-btn color="color1" class="white--text" small>
                      Accept
                    </v-btn>
                  </v-layout>
                  <div class="c-hr"></div>
                  <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
                    <v-icon small v-if="filters.active.customer" color="color1">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    <v-icon small v-else>
                      mdi-checkbox-blank-outline
                    </v-icon>
                    &nbsp;
                    Customer:
                  </v-layout>
                  <div class="c-hr"></div>
                  <v-expand-transition>
                    <div v-show="filters.active.customer">
                      <div style="background: #f7fafc;" class="pt-1 pb-1">
                      </div>
                    </div>
                  </v-expand-transition>

                  <div class="c-hr"></div>
                  <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
                    <v-icon small v-if="filters.active.date" color="color1">
                      mdi-checkbox-marked-outline
                    </v-icon>
                    <v-icon small v-else>
                      mdi-checkbox-blank-outline
                    </v-icon>
                    &nbsp;
                    Date:
                  </v-layout>
                  <div class="c-hr"></div>
                  <v-expand-transition>
                    <div v-show="filters.active.date">
                      <div style="background: #f7fafc;" class="pt-1 pb-1">
                        <v-select
                          v-model="filters.date.mainSelect"
                          class="ma-2 input-slot-thin-border caption"
                          :items="dateFilters"
                          dense
                          hide-details
                          solo
                        ></v-select>
                        <!-- DATE OPTIONS -->
                        <div v-if="filters.date.mainSelect === 'is in the last'">
                          <v-layout class="pl-2 pr-2" style="width: 12em;">
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
          
                              <v-select
                                v-model="filters.date.isInTheLast_select"
                                class="input-slot-thin-border caption"
                                style="flex: 0 0 5em;"
                                :items="['days', 'months']"
                                dense
                                hide-details
                                solo
                              ></v-select>
                          
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is equal to'">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is between'">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            and
                            <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                          <v-layout class="pl-2 pr-2" align-center>
                            <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                            &nbsp;
                            <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                          </v-layout>
                        </div>
                        
                      </div>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-menu>

            </div>

            <!-- selected count -->
            <div v-if="selectedCount > 0"
            key="2"
            class="c-flex-r align-center subheading">
              <v-btn
              icon
              class=""
              @click="selected = {}">
                <v-icon color="color1">close</v-icon>
              </v-btn>
              <div class="text-sans font-weight-bold">
                <span>&nbsp;{{ selectedCount }}</span>
                selected 
              </div>
              <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
              <span class="icon--text ml-2">|</span>
              <v-btn 
              icon
              @click="onDelete">
                <v-icon>delete_outline</v-icon>
              </v-btn>
              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectAll">
                    <v-list-item-title>Select all</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectNone">
                    <v-list-item-title>Select none</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

          </transition>

          <v-spacer></v-spacer>

          <div>
            <transition
            name="fade-transition"
            mode="out-in">
              <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                <span class="grey--text caption">LOADING...</span>&nbsp;
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-layout>
              <div v-else key="L2"></div>
            </transition>
          </div>

        </v-row>
        <!-- end pagination toolbar -->
        <table class="final-table full-width lines-b th-no-padding">
          <colgroup ref="colgroup1">
            <col width="200px">
            <col width="200px">
          </colgroup>

          <tr class="unselectable">
            <c-table-header
            title="Name"
            code="name"
            class="sticky"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="ID"
            code="id"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>
      
          </tr>

          <tr style="">
            <td>
              <v-text-field
              v-model="filters.search.name"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo></v-text-field>
            </td>
            <td>
              <v-text-field
              v-model="filters.search.id"
              placeholder="Search..."
              hide-details
              class="crx-box-input"
              clearable
              color="color1"
              solo></v-text-field>
            </td>
          </tr>

        </table>
        <table class="final-table lines-b pointer hover full-width">
          <colgroup ref="colgroup2">
            <col width="200px">
            <col width="200px">
          </colgroup>

          <list-row
          v-for="item in items" 
          :key="item.id"
          :item="item"
          :itemsMeta="itemsMeta"
          :selected="selected"
          :searchFilters="filters.search"
          @checkRow="checkRow(item)"
          @click.native="clickRow(item)"
          ></list-row>

        </table>

        <!-- BOTTOM TOOLBAR -->
        <v-layout align-center class="border-t--thin">
          <!-- PAGINATION -->
          <c-pagination
          :page="page"
          :pagination="pagination"
          :filters="filters"
          @updatePageNumber="updatePageNumber"
          @goToFirstPage="goToFirstPage"
          @goToPreviousPage="goToPreviousPage"
          @goToNextPage="goToNextPage"
          @goToLastPage="goToLastPage"
          ></c-pagination>
          <!-- PAGINATION -->
        </v-layout>
        <!-- !BOTTOM TOOLBAR -->
        
      </v-card>
      <!-- NEW CARD -->
        
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import ListRow from './components/list-row'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import _ from 'lodash'

export default {
  name: 'samples',
  components: {
    ListRow
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      nextPage: false,
      filters: {
        rowsPerPage: 10,
        sortCol: 'id',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false
        }
      },
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      itemsMeta: {
        newID: null // this will be set to the newst created row
      },
      isLoading: false
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/price-list/' + item.id)
      }
    },
    newPriceList () {
      this.$axios.post('price-lists/create',
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.itemsMeta.newID = response.data.id
          this.page = 0
          this.filters.sortCol = 'id'
          this.filters.sortAscending = false
          Object.keys(this.filters.active).forEach(key => {
            this.filters.active[key] = false
          })
          Object.keys(this.filters.search).forEach(key => {
            this.filters.search[key] = ''
          })
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' price list' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('price-lists/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              console.log('im in here now')
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    loadAPI () {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/price-lists?filters=${encodedFilters}&page=${this.page}`)
        ])
        .then(axios.spread((response) => {
          var rows = response.data.rows
          this.pagination.rowCount = response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          this.items = rows
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>

<style scoped lang="scss">
.hcell {
  display: table-cell;
  vertical-align: middle;
  overflow: hidden;
  border-bottom: 1px solid var(--v-hline-base);
  border-right: 1px solid var(--v-hline-base);
  color: #5f6368;
  font: 400 12px/16px Roboto,Arial,Helvetica,sans-serif;
  font-weight: 500;
  /* height: 32px; */
  letter-spacing: .3px;
  padding: 8px 12px 8px 16px;
  &:last-child {
    border-right: none;
  }
  & .sort-button {
    cursor: pointer;
  }
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

